import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  Avatar,
  IconButton,
} from '@mui/material';
import { motion } from 'framer-motion';
import EmailIcon from '@mui/icons-material/Email';

const leaders = [
  {
    name: 'Hon. Sen. Lenny Kivuti',
    position: 'Executive Chairman & Founder',
    image: '/images/team/lenny.png',
    bio: 'Leading Geomaps with over 40 years of experience in geospatial technology.',
    linkedin: '#',
    email: 'lenny.kivuti@geoafrica.com',
  },
  {
    name: 'Frankline Yawa ',
    position: 'Technical Director',
    image: '/images/team/frank.png',    
    email: 'frankline.yawa@geoafrica.com',
  },
  {
    name: 'Dr. Fausta Mbura Njiru ',
    position: 'GIS Expert',
    image: '/images/team/mbura.png', 
    email: 'fausta.mbura@geomapsafrica.com',
  },
  {
    name: 'Okinyi Sandy',
    position: 'ICT Expert ',
    image: '/images/team/sandy.png',   
    email: 'sandy.okinyi@geoafrica.com',
  },
  {
    name: 'Haniel Nyaga',
    position: 'Finance Officer ',
    image: '/images/team/haniel.png',  
    email: 'haniel.nyaga@geoafrica.com',
  }, 
];

const teamPhotos = [
  { src: '/images/team/Staff1.jpg', alt: 'Team Meeting' },
  { src: '/images/team/Staff2.jpg', alt: 'Field Work' },
  { src: '/images/team/Staff3.jpg', alt: 'Office Team' },
  { src: '/images/team/Geomaps Staff.jpg', alt: 'Project Discussion' },
  { src: '/images/team/Geomatics Team.jpg', alt: 'Training Session' },
  { src: '/images/team/team.jpg', alt: 'Team Building' },
];

const Leadership = () => {
  return (
    <Box>
      {/* Custom Hero Section */}
      <Box
        sx={{
          position: 'relative',
          minHeight: '50vh',
          display: 'flex',
          alignItems: 'center',
          paddingTop: { xs: '160px', md: '180px' },
          paddingBottom: '60px',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("/images/leadership.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            zIndex: 0,
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: '#000',
            opacity: 0.7,
            zIndex: 1,
          },
        }}
      >
        <Container sx={{ position: 'relative', zIndex: 2 }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Typography
              variant="h1"
              color="white"
              sx={{
                fontSize: { xs: '2.5rem', md: '4rem' },
                fontWeight: 700,
                mb: 2,
              }}
            >
              Our Leadership
            </Typography>
            <Typography
              variant="h5"
              color="white"
              sx={{
                maxWidth: '800px',
                opacity: 0.9,
              }}
            >
              Meet the team driving innovation in African geospatial solutions
            </Typography>
          </motion.div>
        </Container>
      </Box>

      {/* Leadership Section */}
      <Box sx={{ py: 12, backgroundColor: '#fff' }}>
        <Container>
          <Grid container spacing={4}>
            {leaders.map((leader, index) => (
              <Grid item xs={12} md={4} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8, delay: index * 0.2 }}
                >
                  <Card sx={{ height: '100%' }}>
                    <CardContent>
                      <Avatar
                        src={leader.image}
                        sx={{ width: 120, height: 120, mb: 2, mx: 'auto' }}
                      />
                      <Typography variant="h5" align="center" gutterBottom>
                        {leader.name}
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        color="primary"
                        align="center"
                        gutterBottom
                      >
                        {leader.position}
                      </Typography>
                      <Typography align="center" sx={{ mb: 2 }}>
                        {leader.bio}
                      </Typography>
                      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <IconButton href={`mailto:${leader.email}`} color="primary">
                          <EmailIcon />
                        </IconButton>
                      </Box>
                    </CardContent>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Team Photos Grid Section */}
      <Box sx={{ py: 8, backgroundColor: '#f8f9fa' }}>
        <Container>
          <Typography
            variant="h3"
            align="center"
            color="primary"
            gutterBottom
            sx={{ mb: 6 }}
          >
            Our Team in Action
          </Typography>
          <Grid container spacing={3}>
            {teamPhotos.map((photo, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8, delay: index * 0.1 }}
                >
                  <Box
                    component="img"
                    src={photo.src}
                    alt={photo.alt}
                    sx={{
                      width: '100%',
                      height: '300px',
                      objectFit: 'cover',
                      borderRadius: 2,
                      boxShadow: 3,
                      transition: 'transform 0.3s ease-in-out',
                      '&:hover': {
                        transform: 'scale(1.02)',
                      },
                    }}
                  />
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default Leadership; 